var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoaded),expression:"isLoaded"}],staticClass:"start-betting",attrs:{"href":_vm.resolveBaseUrl()}},[_vm._v(_vm._s(_vm.$t(("" + _vm.startBetting), _vm.$i18n.locale)))])}
var staticRenderFns = []

export { render, staticRenderFns }